<template slot-scope="scope">
  <div class="device-list">
    <div class="device-list-tab">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#409eff ',
          textAlign: 'center',
          color: '#ffffff',
          padding: '3px',
          fontSize: '12px',
          fontWeight: '400',
          height: '45px',
        }"
        :row-style="{ height: '35px' }"
      >
        <el-table-column label="企业ID" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.companyCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="企业名称" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="select == '0'">{{ scope.row.companyName }}</span>
            <span v-else>{{ scope.row.applyCompanyName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="职位名称"
          align="center"
          show-overflow-tooltip
          v-if="select == '0'"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.targetPositionName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="联系方式"
          align="center"
          show-overflow-tooltip
          width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.contactType == 0 ? "电话" : "微信" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" show-overflow-tooltip width="100">
          <template slot-scope="scope">
            <span>{{
              scope.row.status == 0
                ? "申请中"
                : scope.row.status == 1
                ? "已同意"
                : scope.row.status == 2
                ? "已拒绝"
                : "--"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="时间" align="center" show-overflow-tooltip width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="联系信息"
          align="center"
          show-overflow-tooltip
          v-if="select == '0'"
          width="180"
        >
          <template slot-scope="scope">
            <span
              style="color: #409eff ; text-decoration: underline;cursor: pointer;"
              v-clipboard:copy="scope.row.contact"
              v-clipboard:success="firstCopySuccess"
              v-clipboard:error="firstCopyError"
              >{{ scope.row.contact }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="180" v-else>
          <template slot-scope="scope">
            <span
              class="table-p"
              @click="handelAgree(scope.row)"
              v-if="scope.row.status == 0"
              >同意</span
            >
            <span
              class="table-p"
              @click="handelRefuse(scope.row)"
              v-if="scope.row.status == 0"
              >拒绝</span
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <Instruction
      :dialogVisible="dialogVisible"
      :title="title"
      :Instruction="Instruction"
      :row="row"
      @handleClose="dialogVisible = false"
      @handleUnderstand="handleUnderstand"
    ></Instruction>
  </div>
</template>

<script>
// 引入接口
import {
  agreeProvideContactInfo, //精英同意给予联系方式-个人
  rejectProvideContactInfo, //精英拒绝给予联系方式-个人
} from "../../../../../../assets/api/index";
import Instruction from "../components/Instruction.vue";
export default {
  props: {
    tableData: {},
    select: {},
  },
  components: { Instruction },
  data() {
    return {
      dialogVisible: false,
      title: "",
      Instruction: "",
      row: {},
    };
  },
  computed: {},
  created() {},
  methods: {
    // 点击进行复制 复制成功/失败提示
    firstCopySuccess(e) {
      this.$tool.PromptBox("success", "复制成功");
    },
    firstCopyError(e) {
      this.$tool.PromptBox("error", "复制失败");
    },
    // 同意给联系方式
    handleUnderstand(Number1) {
      console.log(Number1 , 'Number1')
      if (this.title == "同意") {
        var data = {
          data: {
            recordId: this.row.id,
            contact:Number1,
          },
        };
        agreeProvideContactInfo(data).then((res) => {
          if (res.data.code == 0) {
            this.$emit("handelAgree");
            this.$tool.PromptBox("success", "操作成功");
          }
        });
      } else {
        var data = {
          data: {
            recordId: this.row.id,
          },
        };
        rejectProvideContactInfo(data).then((res) => {
          if (res.data.code == 0) {
            this.$emit("handelAgree");
            this.$tool.PromptBox("success", "操作成功");
          }
        });
      }
      this.dialogVisible = false;
    },

    // 同意
    handelAgree(row) {
      console.log(row , 'row')
      this.row = row;
      this.title = "同意";
      this.Instruction =
        row.contactType == 0
          ? "同意让该企业获得你的电话号码"
          : "同意让该企业获得你的微信";
      this.dialogVisible = true;
    },
    //拒绝
    handelRefuse(row) {
      this.row = row;
      this.title = "拒绝";
      this.Instruction =
        row.contactType == 0
          ? "拒绝让该企业获得你的电话号码"
          : "拒绝让该企业获得你的微信";
      this.dialogVisible = true;
    },
    //表格颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "warning-row";
      } else if (rowIndex % 2 == 1) {
        return "success-row";
      }
      return "success-row";
    },
  },
};
</script>

<style scoped lang="less">
/* 主内容区滚动条样式 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  height: 8px; /* 主内容区水平滚动条高度 */
}

/* 强制右侧固定列高度与主内容区相同 */
::v-deep .el-table__fixed-right {
  height: 100% !important; /* 覆盖默认高度计算 */
}
/* 滚动条滑块（可拖动部分）颜色 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #c0c0c0; /* 灰色滑块，比轨道深一些 */
  border-radius: 4px; /* 可选：滑块圆角 */
}
// 兼容火狐
::v-deep .el-table__body-wrapper {
  /* 控制滚动条粗细（对应 WebKit 的 height:8px） */
  scrollbar-width: thin; /* Firefox 中"thin"约 8px 粗细 */
  /* 控制滑块和轨道颜色（对应 WebKit 的 thumb 和 track） */
  scrollbar-color: #c0c0c0 #f5f5f5; /* 滑块色 + 轨道色 */
}
.table-p {
  display: inline-block;
  width: 75px;
  height: 24px;
  border-radius: 5px;
  background: #409eff ;
  text-align: center;
  color: #ffffff;
  line-height: 24px;
  font-family: PingFangSC-Medium;
  font-size: 10px;
  color: #ffffff;
  text-align: center;
  font-weight: 400;
  margin-right: 10px;
  cursor: pointer;
}
.table-added {
  // box-sizing: border-box;
  background: #eeeeee;
  border: 1px solid #999999;
  color: #666666;
  height: 22px;
  line-height: 22px;
}
/deep/th:nth-child(1) {
  border-radius: 10px 0 0 0 !important;
}
/deep/th:nth-child(8) {
  border-radius: 0px 10px 0px 0px !important;
}
// /deep/th:nth-last-child(1) {
//   border-radius: 0 10px 0 0 !important;
// }

/deep/th {
  height: 45px !important;
  padding: 0;
}
/deep/ td {
  height: 40px !important;
  padding: 0;
}
.device-list-tab {
  border: 1px solid #eeeeee;
  border-radius: 10px 10px 0 0;
}
/deep/.el-table__empty-block,
/deep/.el-table tr,
/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
  color: #333333;
  font-weight: 400;
  font-size: 12px;
}
/deep/.el-table .warning-row td {
  font-size: 12px;
  color: #333333;
}

::v-deep .el-table .warning-row td {
  background: #eeeeee !important;
}
/deep/.device-list {
  border: 1px solid goldenrod !important;
}
</style>
